<template>
    <div :class="theme" id="doc">
        <div id="l-hd">
            <!--        <span class="logo"></span>-->
            <span class="corner" id="corner"></span>
        </div>
        <div class="cf" id="l-bd">
            <div class="promotion-banner" id="topic">
                <div class="login-section-bg" id="section">

                    <div class="login-section">
                        <div class="login-tab login-tab-form">
                            <a class="login-toggle login-toggle-form is-active" data-type="form">欢迎登录渠道后台</a>
                        </div>
                        <div class="login-container login-form-container">
                            <form action="/login" class="login-form" id="form-submit" method="post">
                                <div class="form-field form-field--icon">
                                    <i class="icon icon-user"></i>
                                    <el-input placeholder="请输入账号" v-model="userName">
                                        <span class="glyphicon glyphicon-user" slot="prepend"></span>
                                    </el-input>
                                    <!-- <input type="text" id="login-username" name="username" placeholder="用户名，不包含@后缀" value=""> -->
                                </div>
                                <div class="form-field form-field--icon">
                                    <i class="icon icon-password"></i>
                                    <el-input placeholder="请输入密码" type="password" v-model="password">
                                        <span class="el-icon-edit" slot="prepend"></span>
                                    </el-input>
                                    <!-- <input type="password" id="login-password" name="password" placeholder="密码" value=""> -->
                                </div>
                                <div class="login-cf">
                                </div>
                                <div class="form-field form-field-submit">
                                    <input @click="login()" class="btn btn-login-submit" name="commit" type="button"
                                           value="登录">
                                    <p class="show-info" style="">
                                        若您遇到任何问题，请联系商务顾问！
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped src="../../../public/static/login.css"></style>

<script>

import BasicPager from '../../mixins/BasicPager'
import SysModel from '../../framework/models/sysModel'

export default {
  name: 'Login',
  extends: BasicPager,
  data: function () {
    return {
      userName: '',
      password: '',
      theme: 'blue-bg',
      publicKey: null,
      exponent: null,
      loginType: 'channel'
    }
  },
  created: function () {
    let params = this.$route.params
    this.loginType = params.loginType
    let themes = ['yellow-bg']
    let position = Math.ceil(Math.random() * themes.length) - 1
    this.theme = themes[position]
    this.getPublicKey()
  },
  methods: {
    getPublicKey: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.publicKey = datas.publicKey
          _this.exponent = datas.exponent

          $.jCryption.crypt.setPublicKey(datas.publicKey)
        }
      }
      SysModel.getPublicKey(_this, listener)
    },

    login: function () {
      let password = this.password
      let _this = this

      let loginData = {
        'loginAccount': this.userName,
        'password': password
      }

      let jsonStr = JSON.stringify(loginData)
      let subJson = this.jsonSubstring(jsonStr)

      var res = $.jCryption.crypt.encrypt(subJson)

      let params = {
        'param': res
      }

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          datas.loginTime = new Date().getTime()
          _this.saveLoginInfo(datas)

          // 跳转

          let userInfo = null
          if (localStorage.userInfo) {
            userInfo = JSON.parse(localStorage.userInfo)
          }

          if (userInfo) {
            if (userInfo.loginPath === 'channel') {
              _this.$router.push('/home/channelDataTrend')
            } else {
              _this.$router.push('/home/clueDataTrend')
            }
          }

          window.location.reload()
        }
      }

      if (_this.loginType === 'channel') {
        SysModel.channelLogin(_this, params, listener)
      } else if (_this.loginType === 'cxh') {
        SysModel.sxbCrmLogin(_this, params, listener)
      }
    },
    jsonSubstring: function (str) {
      let len = str.length
      return str.substring(1, len - 1)
    },
    changeBackground: function () {
      $('.change-bg').on('click', function () {
        var id = $(this).context.id
        // 背景色、价值观、右上角的颜色变换
        changeBgColor(id)
        _ls.setItem('color', id)
      })
    }
  }
}
</script>
